module.exports = __webpack_public_path__ + "img/Poland.83c41a4b.png";